import { z } from "zod";
import { api } from "../helpers/apiClient";
import {
  ListedReferralCodeSchema,
  ReferralCodeSchema,
  type CreateReferralCodeRequest,
  type ListedReferralCode,
  type ReferralCode,
} from "../referrals/types";

export {
  REFERRAL_CODE_PATTERN,
  CreateReferralCodeRequestSchema,
  ListedReferralCodeSchema,
  ReferralCodeSchema,
  deriveReferralCodeStatus,
} from "../referrals/types";
export type {
  CreateReferralCodeRequest,
  ListedReferralCode,
  ReferralCode,
  ReferralCodeStatus,
} from "../referrals/types";

export const listReferralCodes = () =>
  api.get<ListedReferralCode[]>("/referral-codes", {}, 0, z.array(ListedReferralCodeSchema));

export const createReferralCode = (data: CreateReferralCodeRequest) =>
  api.post<ReferralCode>("/referral-codes", data, ReferralCodeSchema);
